import { useState } from 'react';

import { Time } from '~/constants/variables';
import { useGlobal } from '~/hooks/useGlobal';
import { useIsomorphicLayoutEffect } from '~/hooks/useIsomorphicLayoutEffect';

export const usePromoCountdown = (
  promoEndDate: Nullable<string>,
): {
  isExpired: boolean;
  remainingMs: number | null;
  hasEndDate: boolean;
} => {
  const { serverNow } = useGlobal();
  const parsed = promoEndDate ? Date.parse(promoEndDate) : Number.NaN;
  const endMs = Number.isNaN(parsed) ? null : parsed;
  const [now, setNow] = useState<number | null>(null);

  useIsomorphicLayoutEffect(() => {
    if (endMs === null) {
      return;
    }

    setNow(Date.now());
    const timer = setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= endMs) {
        clearInterval(timer);
      }
    }, Time.Second);

    return () => clearInterval(timer);
  }, [endMs]);

  if (endMs === null) {
    return { isExpired: false, remainingMs: null, hasEndDate: false };
  }

  return {
    isExpired: endMs <= (now ?? serverNow ?? Date.now()),
    remainingMs: now === null ? null : Math.max(endMs - now, 0),
    hasEndDate: true,
  };
};
